export const dateLocalISO = (date) => {
    if (!date) return "";
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    return date.toISOString().slice(0, 10);
};
